import React, { useRef } from 'react';

import './ImageInputWithPreview.css';

const ImageInputWithPreview = ({
  name,
  imagePreviewUrl,
  imageUrl,
  selectedImgAlt,
  currentImgAlt,
  noImgMsg,
  onFileChange,
  onRemoveImage,
  previewShape = 'square',
  className = '',
  ...rest
}) => {
  const fileInputRef = useRef();

  const imageInputWithPreviewClassNames = [
    'modal-image-input-with-preview',
    className,
  ].join(' ');

  const previewClassNames = [
    'modal-image-preview-container',
    previewShape === 'circle' ? 'circle' : '',
    className,
  ].join(' ');

  const handleRemoveImage = (name) => {
    if (fileInputRef.current) fileInputRef.current.value = '';
    onRemoveImage(name);
  };

  return (
    <div className={imageInputWithPreviewClassNames} {...rest}>
      <div className={previewClassNames}>
        {imagePreviewUrl ? (
          <img
            className='modal-img'
            src={imagePreviewUrl}
            alt={selectedImgAlt}
          />
        ) : imageUrl ? (
          <img className='modal-img' src={imageUrl} alt={currentImgAlt} />
        ) : (
          <div className='modal-no-photo-selected-container'>
            <span>{`No photo selected\n${noImgMsg || ''}`}</span>
          </div>
        )}
      </div>
      <div className='modal-manage-file-container'>
        <div className='modal-choose-file-container'>
          <input
            type='file'
            name={name}
            accept='image/*'
            onChange={onFileChange}
            ref={fileInputRef}
            className='modal-choose-file'
          />
        </div>
        <div className='modal-delete-button-container'>
          <button
            type='button'
            onClick={() => handleRemoveImage(name)}
            className='modal-delete-button'
          >
            Remove File
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageInputWithPreview;
